import script from "./Projects.vue?vue&type=script&setup=true&lang=js"
export * from "./Projects.vue?vue&type=script&setup=true&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=fc692ff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc692ff0"]])

export default __exports__